<template>
  <footer class="footer">
    <div class="footer__img" :style="bgImg('/img/jpg/CONTACTO.jpg')"></div>
    <div class="footer__info">
      <div class="footer__info--title">Oficinas</div>
      <div class="footer__info--province">
        <div class="col">
          <p class="title">Buenos Aires</p>
          <p>CABA</p>
        </div>
        <div class="col right">
          <p>Gascón 1057 - 6B</p>
          <!-- <p>011 2094 2921</p> -->
        </div>
      </div>
      <div class="footer__info--province">
        <div class="col">
          <p class="title">Chaco</p>
          <p>Resistencia</p>
        </div>
        <div class="col right">
          <p>Av.Italia 2315</p>
          <!-- <p>0362 4979351</p> -->
        </div>
      </div>

      <a href="https://agenciacirculo.typeform.com/to/XakwyC" target="_blank" class="contact--form__button typeform_button">
        Sé parte del team
      </a>
    </div>
  </footer>
</template>
<script>
import mixins from '@/mixins/mixins'

export default {
  mixins: [mixins]
}
</script>
